module.exports = __webpack_public_path__ + "img/Lisa-DREI.45732838.jpg";